import { insertChemicalSchema, type Chemical } from "../platform/schema";

export const CHEMICAL_EDITABLE_FIELDS = [
  "productNumber", "batchNumber", "name", "casNumber", "location", "unit",
] as const satisfies readonly (keyof Chemical)[];

export type ChemicalEditableField = typeof CHEMICAL_EDITABLE_FIELDS[number];

export const CHEMICAL_EDITABLE_MASK = Object.fromEntries(
  CHEMICAL_EDITABLE_FIELDS.map((field) => [field, true]),
) as Record<ChemicalEditableField, true>;

export function pickEditableChemicalFields<T extends Record<ChemicalEditableField, unknown>>(data: T): Pick<T, ChemicalEditableField> {
  return Object.fromEntries(CHEMICAL_EDITABLE_FIELDS.map((field) => [field, data[field]])) as Pick<T, ChemicalEditableField>;
}

export const chemicalEditInputSchema = insertChemicalSchema.pick(CHEMICAL_EDITABLE_MASK);
